import { useLazyQuery } from "@apollo/client/react";import React, { useEffect, useState } from 'react';

import CloseIcon from '@mui/icons-material/Close';
import { Box, IconButton } from "@mui/material";
import { CustomDialog } from "../../../components/customDialog/CustomDialog";
import InfoRow from "../../MisVisitasCreation/components/components/InfoRow/InfoRow";
import { RenderInputByTypeMobile } from '../../../components/formGroupGenerator/RenderInputByTypeMobile';
import { useGetAction } from '../hooks/useGetAction';
import { GET_PROFESIONALES_EVALUACION, adaptProfesionales } from '../../../data/graphQL/queries/MisVisitas/getProfesionalesEvaluacion';

export const NewNotificationModal = ({ openModal, setOpenModal, cabecera, handleSearch }) => {
  const [notification, setNotification] = useState(cabecera);
  const [profesionales, setProfesionales] = useState([]);

  const [getProfesionalesEvaluacion, { data: dataProfesionales , error, loading: profesionalLoading }] = useLazyQuery(GET_PROFESIONALES_EVALUACION, {
    fetchPolicy: 'no-cache'
  });

	useEffect(() => {
		if (!dataProfesionales) return;
    if (!!dataProfesionales) {
      const dataAdapted = adaptProfesionales(dataProfesionales || []);
      setProfesionales(dataAdapted);
    }
	}, [dataProfesionales]);  

  useEffect(() => {
    setNotification((prev) => ({
      ...prev,
      idEvaluacion: cabecera?.idEvaluacion
    }));
  }, [cabecera]);

  useEffect(() => {
    if (!isNaN(cabecera?.idEvaluacion) && cabecera?.idEvaluacion !== null && !profesionalLoading)
    getProfesionalesEvaluacion({ variables: { idEvaluacion: cabecera?.idEvaluacion } });
  }, [cabecera?.idEvaluacion]);

  const { handleCreateNotification, loading } = useGetAction();

  const handleCloseModal = () => {
    setOpenModal(false);
    setNotification((prev) => ({
      ...prev,
      ['idProfesional']: null,
      ['observacion']: ''
    }));
  };

  const handleChange = (name, value) => {
    setNotification((prev) => ({
      ...prev,
      [name]: value
    }));
  };

  useEffect(() => {
    if (!loading) handleSearch();
  }, [loading]);

  return (
    <CustomDialog
      open={openModal}
      onAccept={() => {handleCreateNotification(notification);handleCloseModal();}}
      onBackdropClick={handleCloseModal}
      acceptText="Notificar"
      title="Nueva Notificación"
      maxWidth="sm"
      fullWidth>
      
            <IconButton onClick={handleCloseModal} sx={{ display: 'block', position: 'absolute', top: '4px', right: '8px' }}>
                <CloseIcon />
            </IconButton>

            <InfoRow label="HC" value={cabecera?.idPaciente} />
            <InfoRow label="#" value={cabecera?.idEvaluacion} />
            <InfoRow label="Paciente" value={cabecera?.paciente} />

            <Box sx={{ marginBottom: '1rem' }}>
                <RenderInputByTypeMobile
          input={{
            displayName: 'Profesional',
            name: 'idProfesional',
            type: "select",
            options: profesionales
          }}
          handleChange={(_, value) => handleChange('idProfesional', value)}
          value={notification?.idProfesional} />
        
            </Box>
            <RenderInputByTypeMobile
        input={{
          displayName: 'Observación',
          name: 'observacion',
          type: "long_string"
        }}
        handleChange={(_, value) => handleChange('observacion', value)}
        value={notification?.observacion} />
      
        </CustomDialog>);

};